export default __webpack_public_path__ + "static/media/m_session8_48.9fae2d93.png";